import React, { Component } from 'react'
import ModalImage from 'react-modal-image'
import { connect } from 'react-redux'
import './Lightbox.scss'

class ImageMessage extends Component {
  render() {
    const { message } = this.props
    if (!message.string) return null

    const altImage = JSON.parse(message.string)

    return (
      <ModalImage
        className="lightBox"
        small={message.thumbUrl}
        large={message.imageUrl}
        alt={altImage.fileName.replace(/\.[^/.]+$/, '')}
        showRotate
        hideDownload
      />
    )
  }
}

export default connect()(ImageMessage)
